// extracted by mini-css-extract-plugin
module.exports = {"container":"loginLayout_container__3IsHu","box":"loginLayout_box__3WzNZ","sidebar":"loginLayout_sidebar__3idlH","main":"loginLayout_main__24Sgy"};